import { useState } from 'react';
import './Presse.css';

const PRESS_ARTICLES = [
  {
    publication: 'La Maison Tunisienne',
    edition: 'Nouvelle Collection Héritage',
    title: '"Nouvelle Collection Héritage"',
    images: [
      'https://static.wixstatic.com/media/90a441_4d35f4d3dd314bacb198418b213845f7~mv2.jpg',
      'https://static.wixstatic.com/media/90a441_931b671d2474432f9deb422556da3e44~mv2.jpg',
      'https://static.wixstatic.com/media/90a441_3efd0b385df54796a403f0c23881e527~mv2.jpg',
      'https://static.wixstatic.com/media/90a441_747b53d03fad419c8b56c03fad1fbc1a~mv2.jpg',
    ],
  },
  {
    publication: 'Maison de Tunisie',
    edition: 'N°42',
    title: '"Khansa Yazidi, l\'Histoire d\'une passion"',
    images: [
      'https://static.wixstatic.com/media/90a441_1727a64e9a1a4f3d8dfa4f2351388e1a~mv2.jpg',
      'https://static.wixstatic.com/media/90a441_4dfa0f592c5d4bb0aa5f8c120e334bb5~mv2.jpg',
      'https://static.wixstatic.com/media/90a441_dddc6ac5d4684f34ad5783e5dd95a30c~mv2.jpg',
      'https://static.wixstatic.com/media/90a441_f633e25c68574ab1ba39f7d20a988595~mv2.jpg',
    ],
  },
  {
    publication: 'La Maison Tunisienne',
    edition: 'N°35',
    title: '"Khansa Yazidi, Des Créations Qui Parlent Aux Sens"',
    images: [
      'https://static.wixstatic.com/media/90a441_3a571698db774fda8beb72978a234835~mv2.jpg',
      'https://static.wixstatic.com/media/90a441_e946c9ecde544f27978212230c916b8f~mv2.jpg',
      'https://static.wixstatic.com/media/90a441_fe05d089819a4eb38ca669b844de7ace~mv2.jpg',
      'https://static.wixstatic.com/media/90a441_c2bcccb9aa0e4c5e8d407af83b8c2d33~mv2.jpg',
    ],
  },
  {
    publication: 'Maison de Tunisie',
    edition: '',
    title: '"Khansa Yazidi, l\'art de la salle de bain"',
    images: [
      'https://static.wixstatic.com/media/90a441_b1daa7e6131b4dde9873ef90316280ae~mv2.jpg',
      'https://static.wixstatic.com/media/90a441_410e139a8f4b4d1bbbfa4ee23bf8423f~mv2.jpg',
      'https://static.wixstatic.com/media/90a441_7ca95df55a474187886fa9ba03284c8e~mv2.jpg',
      'https://static.wixstatic.com/media/90a441_c2ab15b6df594736a98f60ef94e73790~mv2.jpg',
      'https://static.wixstatic.com/media/90a441_e3579890f4ef4bcfbcb2c6e2ccde9d5c~mv2.jpg',
      'https://static.wixstatic.com/media/90a441_a3ae96c0350d46c7bb06271e1c096113~mv2.jpg',
      'https://static.wixstatic.com/media/90a441_a0f927f0738b457b80b1d11f4dc21a52~mv2.jpg',
      'https://static.wixstatic.com/media/90a441_94ff30c7b9b7495590982f0df845322c~mv2.jpg',
    ],
  },
  {
    publication: 'La Maison Tunisienne',
    edition: 'N°31',
    title: '"Khansa Yazidi, Une marque tunisienne qui ne laisse pas indifférent"',
    images: [
      'https://static.wixstatic.com/media/90a441_9dbceeee42c04f7c8482b6141ce14074~mv2.jpg',
      'https://static.wixstatic.com/media/90a441_b46e81f68e3d4349885a48cc6015e715~mv2.jpg',
    ],
  },
  {
    publication: 'Iddéco',
    edition: 'N°35',
    title: 'Participation Dar Deco 2017',
    images: [
      'https://static.wixstatic.com/media/90a441_d6010b177adf460381d916f5738be8a2~mv2.jpg',
      'https://static.wixstatic.com/media/90a441_2965ceaef9874781b3467d2f9526e458~mv2.jpg',
    ],
  },
  {
    publication: 'Hello Design Mag',
    edition: '',
    title: '"Un nouveau showroom dédié à l\'univers de la salle de bain au design minimaliste"',
    images: [
      'https://static.wixstatic.com/media/90a441_f732d18c00ae48108815958b084f467e~mv2.jpg',
      'https://static.wixstatic.com/media/90a441_03b854f4a6594daf848567e0b3e974b5~mv2.jpg',
      'https://static.wixstatic.com/media/90a441_2e3790076c7b4e5da0f1a48813861cbb~mv2.jpg',
    ],
  },
  {
    publication: 'Ideo Magazine',
    edition: '',
    title: '"Khansa Yazidi, la designer qui illumine vos salles de bain, inaugure son nouveau show-room"',
    images: [
      'https://static.wixstatic.com/media/90a441_e5cc30c207b24f79b09d468d2e64cde3~mv2.jpg',
      'https://static.wixstatic.com/media/90a441_126b0206e8ac4cf8805ff777c7b7357a~mv2.jpg',
    ],
  },
  {
    publication: 'L\'instant M magazine',
    edition: '',
    title: '"Une Touche D\'écoresponsabilité à Votre Décoration Avec Khansa Yazidi"',
    images: [
      'https://static.wixstatic.com/media/90a441_0bfec64100d44c9f96034297137f66f8~mv2.jpg',
      'https://static.wixstatic.com/media/90a441_d64ea7ba74cf447084f8042da78325b9~mv2.jpg',
      'https://static.wixstatic.com/media/90a441_ee748005c056499e8ff6d9f6b23cc245~mv2.jpg',
    ],
  },
  {
    publication: 'Hello Design Mag',
    edition: '',
    title: '"Ces accessoires de salle de bain en laiton by Khansa Yazidi ont tout pour plaire"',
    images: [
      'https://static.wixstatic.com/media/90a441_dca43c085eff414c83c26a2735686d55~mv2.jpg',
      'https://static.wixstatic.com/media/90a441_f3a9610d87fb4d328dda19e6384f64a4~mv2.jpg',
      'https://static.wixstatic.com/media/90a441_b45d752366ce4d6b87c9cf09bd7a72c1~mv2.jpg',
      'https://static.wixstatic.com/media/90a441_982604377ac941f2b9a0dfa37566ef65~mv2.jpg',
    ],
  },
  {
    publication: 'Tunideco.net',
    edition: '',
    title: 'Astuce de grand-mère : Comment entretenir le laiton By Khansa Yazidi ?',
    images: [
      'https://static.wixstatic.com/media/90a441_569809cb582e456bb9c0cf8b9838d87a~mv2.jpg',
      'https://static.wixstatic.com/media/90a441_b9e2a415368440a3b3872132969f9e9a~mv2.jpg',
    ],
  },
  {
    publication: 'L\'instant M magazine',
    edition: '',
    title: '"Khansa Yazidi : Une Autre Manière De Concevoir Votre Déco"',
    images: [
      'https://static.wixstatic.com/media/90a441_d585611b0421411aa5c1adb16a6f1085~mv2.jpg',
      'https://static.wixstatic.com/media/90a441_058124e307dd423294a444755a7df264~mv2.jpg',
      'https://static.wixstatic.com/media/90a441_4a7a120878b1451a9930642b70ff6f28~mv2.jpg',
      'https://static.wixstatic.com/media/90a441_82c7f023057e42dd9c64451ae45611d1~mv2.jpg',
      'https://static.wixstatic.com/media/90a441_8bfcd26c14db44e0a6b55141f8a9e0d5~mv2.jpg',
    ],
  },
  {
    publication: 'Tunideco.net',
    edition: '',
    title: '"Robinetterie et accessoires 100% tunisiens conçus par Khanssa Yazidi"',
    images: [
      'https://static.wixstatic.com/media/90a441_5aecb38f1f6943e9976529f056cddd89~mv2.jpg',
      'https://static.wixstatic.com/media/90a441_c655cad80415419ea59ae262d3ba81e9~mv2.jpg',
      'https://static.wixstatic.com/media/90a441_4bb5829d7f5549b3b2d4c9166da8ff78~mv2.jpg',
      'https://static.wixstatic.com/media/90a441_640ecef7825b4979a8b81bf15f54085a~mv2.jpg',
    ],
  },
  {
    publication: 'Hello Design Mag',
    edition: '',
    title: '"Khansa Yazidi: la figure montante du design tunisien"',
    images: [
      'https://static.wixstatic.com/media/90a441_8ddcada40b564ad7b4f848e0ed6b7b1c~mv2.jpg',
      'https://static.wixstatic.com/media/90a441_f41b7ef19b0845dabb466ba56d98e138~mv2.jpg',
      'https://static.wixstatic.com/media/90a441_c9becc805912467baf6a86ceb0bfb930~mv2.jpg',
    ],
  },
];

// Lightbox component
function Lightbox({ images, startIndex, onClose }) {
  const [current, setCurrent] = useState(startIndex);

  const prev = (e) => { e.stopPropagation(); setCurrent((c) => (c - 1 + images.length) % images.length); };
  const next = (e) => { e.stopPropagation(); setCurrent((c) => (c + 1) % images.length); };

  // Keyboard nav
  const handleKey = (e) => {
    if (e.key === 'ArrowLeft') setCurrent((c) => (c - 1 + images.length) % images.length);
    if (e.key === 'ArrowRight') setCurrent((c) => (c + 1) % images.length);
    if (e.key === 'Escape') onClose();
  };

  return (
    <div className="lightbox" onClick={onClose} onKeyDown={handleKey} tabIndex={0} autoFocus>
      <button className="lightbox__close" onClick={onClose}>✕</button>
      <button className="lightbox__arrow lightbox__arrow--prev" onClick={prev}>‹</button>
      <div className="lightbox__img-wrap" onClick={(e) => e.stopPropagation()}>
        <img src={images[current]} alt={`Page ${current + 1}`} className="lightbox__img" />
        <div className="lightbox__counter">{current + 1} / {images.length}</div>
      </div>
      <button className="lightbox__arrow lightbox__arrow--next" onClick={next}>›</button>
    </div>
  );
}

// Article block
function ArticleBlock({ article }) {
  const [lightbox, setLightbox] = useState(null); // null or index

  return (
    <article className="press-article">
      <div className="press-article__header">
        <div className="press-article__meta">
          <span className="press-article__pub">{article.publication}</span>
          {article.edition && <span className="press-article__edition">{article.edition}</span>}
        </div>
        <h2 className="press-article__title">{article.title}</h2>
        <div className="press-article__divider" />
      </div>

      <div className="press-article__gallery">
        {article.images.map((img, i) => (
          <div
            key={i}
            className="press-article__thumb"
            onClick={() => setLightbox(i)}
          >
            <img src={img} alt={`${article.publication} – page ${i + 1}`} />
            <div className="press-article__thumb-overlay">
              <span>+</span>
            </div>
          </div>
        ))}
      </div>

      {lightbox !== null && (
        <Lightbox
          images={article.images}
          startIndex={lightbox}
          onClose={() => setLightbox(null)}
        />
      )}
    </article>
  );
}

export default function Presse() {
  return (
    <main className="presse-page">
      {/* Banner */}
      <div className="presse-page__banner">
        <div className="presse-page__banner-content">
          <span className="section-label">Ils parlent de nous</span>
          <h1 className="presse-page__title">Presse</h1>
          <div className="presse-page__divider" />
          <p className="presse-page__subtitle">
            Khansa Yazidi dans les magazines et médias tunisiens et internationaux
          </p>
        </div>
      </div>

      {/* Articles */}
      <div className="presse-page__body">
        {PRESS_ARTICLES.map((article, i) => (
          <ArticleBlock key={i} article={article} />
        ))}
      </div>

      {/* Bottom CTA */}
      <div className="presse-page__cta">
        <span className="section-label">Demande Presse</span>
        <h3 className="presse-page__cta-title">Vous souhaitez nous couvrir ?</h3>
        <a href="mailto:yazidi.khansa@gmail.com?subject=Demande%20Presse" className="btn-outline">
          Contactez-nous
        </a>
      </div>
    </main>
  );
}
